$(document).one('scroll mouseenter touchstart', function () {
  const phoneInputField = document.querySelector("#phone_number");
  if (phoneInputField) {
    var $country_geo;
    if (window.location.href.indexOf("nmi-payments-au") > -1) {
      $country_geo = 'au';
    } else {
      $country_geo = 'us';
    }

    const phoneInput = window.intlTelInput(phoneInputField, {
      initialCountry: $country_geo,
      formatOnDisplay: true,
      separateDialCode: false,
      countrySearch: false,
      strictMode: true,
      customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
        return "e.g." + selectedCountryPlaceholder;
      }
    });

    $('#phone_number').data('phoneInput', phoneInput);

  const input = phoneInputField;
  const errorMsg = document.querySelector("#error-msg");

  // here, the index maps to the error code returned from getValidationError - see readme
  const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

  const reset = () => {
    phoneInputField.classList.remove("error");
    errorMsg.innerHTML = "";
    errorMsg.classList.add("hide");
  };

  const showError = (msg) => {
    phoneInputField.classList.add("error");
    errorMsg.innerHTML = msg;
    errorMsg.classList.remove("hide");
  };

    phoneInputField.addEventListener('change', () => {
      reset();
      if (!input.value.trim()) {
        showError("Required");
      } else if (phoneInput.isValidNumberPrecise()) {
        //validMsg.classList.remove("hide");
        $('input[name="country"]').attr('value', phoneInput.getSelectedCountryData()['iso2']);
        $('input[name="phone"]').attr('value', phoneInput.getNumber());
      } else {
        const errorCode = phoneInput.getValidationError();
        const msg = errorMap[errorCode] || "Invalid number";
        showError(msg);
      }
    });
  }

  if ($('#talk-to-our-team').length) {
    irisValidation($('#talk-to-our-team'), {
      focusFirstInput: false,
      validators: {
        firstname: 'firstName',
        lastname: 'lastName',
        email: 'email',
        company: 'companyName',
      },
      filters: {
        utm_source: 'utm_param',
        utm_campaign: 'utm_param',
        utm_medium: 'utm_param',
        conversion_url: 'page_url',
        utm_gclid: 'utm_param',
        utm_term: 'utm_param',
        utm_content: 'utm_param',
        pagename: 'page_url',
      },
      validateByTimeout: ['email'],
      errorMessages: {
        required: 'This field is required',
        emailFormat: 'Not a valid email',
        connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
      },
      success: function (data) {
        $('#postform').remove();
        console.log('st-1');
        var currentForm = $('#talk-to-our-team').data('irisFormValidator');
        var form = document.createElement("form");
        var cpRouter = 'website-meeting-request';
        if ($('#cpRouter').length && $('#cpRouter').val().length) {
          cpRouter = $('#cpRouter').val();
        }
        form.id = "postform";
        form.name = "postform";
        form.action = "https://tools.forchili.com/pardot/api/v1/success/nmi/" + cpRouter + "?successLocation=" + location.protocol + '//' + location.host + "/thank-you/";
        form.method = "post";
        form.style = "display: none";
        console.log('st-2');
        var formData = currentForm.getFormData();
        Object.keys(formData).forEach(function (key) {
          if ((['conversion_url', 'additionaldata', 'pagename', 'token', 'utm_campaign', 'utm_content', 'utm_gclid', 'utm_medium', 'utm_source', 'utm_term']).indexOf(key) == -1) {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = formData[key];
            form.appendChild(input);
          }
        });
        console.log('st-3');
        document.body.appendChild(form);
        console.log('st-4');
        $('#postform').submit();
        console.log('st-5');
        console.log('out');
      }
    });
  }
});
$(document).one('OneTrustLoaded', function () {
  if($('#phone_number').length) {
    var country = window.OneTrust.getGeolocationData()['country'];
    $('input[name="country"]').attr('value', country);
    $('#phone_number').data('phoneInput').setCountry(country);
  }
});


